<mat-progress-spinner *ngIf="data.progress" mode="indeterminate" diameter="15"></mat-progress-spinner>
<div style="flex: 1">
  <div *ngIf="data.head" class="tc-toaster-head">{{ data.head }}</div>
  <div *ngIf="data.body" class="tc-toaster-body">{{ data.body }}</div>
  <div *ngIf="data.html" class="tc-toaster-body" [innerHTML]="data.html"></div>
</div>
